export default __webpack_public_path__ + "static/media/ctu.bbab004f.png";